import React, { memo, useEffect, useRef, useState } from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { detailsPath } from './companyFormat'
import StarRating, { formatRating } from './StarRating'

export const PAGE_SIZE = 20

export const companyKey = (item) => `${item.sourceId}-${item.id}`

// Palavras que ficam minusculas no meio do texto ("Rua das Flores").
const SMALL_WORDS = new Set(['de', 'da', 'do', 'das', 'dos', 'e'])

// Muitos cadastros vem em CAIXA ALTA. So converte quando o texto inteiro esta em maiusculas,
// para nao estragar nomes ja escritos do jeito certo.
export function softCase(text) {
  if (!text || text !== text.toUpperCase() || !/[A-ZÀ-Ý]/.test(text)) return text || ''
  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => (index > 0 && SMALL_WORDS.has(word) ? word : word.replace(/(^|[-/.])(\p{L})/gu, (m, sep, ch) => sep + ch.toUpperCase())))
    .join(' ')
}

export { formatRating }

// Logo quando a oficina tem; senao a inicial do nome num quadro neutro (mantem o alinhamento).
function CompanyThumb({ item, name }) {
  if (item.logo) {
    return <span className='cp-row-thumb'><img src={item.logo} alt='' loading='lazy' /></span>
  }
  const initial = (name || '?').trim().charAt(0).toUpperCase()
  return <span className='cp-row-thumb cp-row-thumb-initial' aria-hidden='true'>{initial}</span>
}

function addressLine(item) {
  const street = [softCase(item.street), item.streetNumber].filter(Boolean).join(', ')
  return [street, softCase(item.neighborhood)].filter(Boolean).join(' · ')
}

// Clique comum escolhe a oficina (onSelect); Ctrl/Cmd/Shift + clique ou botao do meio
// mantem o comportamento normal do link (abrir em outra aba).
const isPlainClick = (event) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey

function List({ list, selectedKey, onSelect, initialVisible = PAGE_SIZE, onVisibleChange }) {
  const [visible, setVisible] = useState(initialVisible)
  const firstList = useRef(list)

  // Nova busca ou novo filtro: volta para o comeco da lista (mas nao ao montar,
  // para respeitar o quanto ja estava aberto ao voltar do detalhe).
  useEffect(() => {
    if (list !== firstList.current) setVisible(PAGE_SIZE)
  }, [list])

  useEffect(() => {
    if (onVisibleChange) onVisibleChange(visible)
  }, [visible, onVisibleChange])

  if (!list.length) {
    return <p className='cp-empty'>Nenhuma empresa encontrada com esses filtros.</p>
  }

  const shown = list.slice(0, visible)

  return (
    <div className='cp-list-panel'>
      <ul className='cp-list'>
        {shown.map(item => {
          const branch = item.Branches ? item.Branches.description : ''
          const reviews = Number(item.amountOfSatisfactionSurvey) || 0
          const key = companyKey(item)
          const name = softCase(item.tradingName || item.name)
          const isSelected = key === selectedKey

          return (
            <li key={key}>
              <a
                className={`cp-row${isSelected ? ' is-selected' : ''}`}
                href={detailsPath(item)}
                aria-current={isSelected ? 'true' : undefined}
                onClick={event => {
                  if (!onSelect || !isPlainClick(event)) return
                  event.preventDefault()
                  onSelect(item)
                }}
              >
                <CompanyThumb item={item} name={name} />
                <span className='cp-row-main'>
                  <strong className='cp-row-name'>{name}</strong>
                  <span className='cp-row-meta'>
                    {reviews > 0
                      ? <StarRating value={item.rating} count={reviews} />
                      : <span>Sem avaliações</span>
                    }
                    {branch && <span className='cp-row-branch'>{branch}</span>}
                  </span>
                  <span className='cp-row-address'>{addressLine(item)}</span>
                </span>
                <FontAwesomeIcon icon={faChevronRight} className='cp-row-chevron' aria-hidden='true' />
              </a>
            </li>
          )
        })}
      </ul>

      {list.length > visible &&
        <div className='cp-list-more'>
          <span>Mostrando {shown.length} de {list.length}</span>
          <button type='button' onClick={() => setVisible(v => v + PAGE_SIZE)}>Mostrar mais</button>
        </div>
      }
    </div>
  )
}

export default memo(List);
